import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { billingSelectorToQueryString } from '@debbie/cortex/dist/api/billing.js';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors.js';
import { File } from '../index.js';
import { APIBASE } from '../../config.js';
import THEME from '../../theme.js';
import { getBillingIdentity } from '../Billing.js';
import { getFile } from '@debbie/cortex/dist/files.js';
import ObjectComp from '../ObjectComp.js';
const PDFPreview = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenantId = useSelector(selectTenantId);
    const currentLang = useSelector((s) => s.currentLang);
    const identity = getBillingIdentity(props.billing, lang);
    const [pdfObject, setPdfObject] = useState(null);
    const PDFURL = `${APIBASE}/v1/${tenantId}/billings/${props.billingSelector ? 'ongoing-work-billing' : props.billing.billingId}/pdf?lang=${currentLang}&${props.billingSelector
        ? billingSelectorToQueryString(props.billingSelector)
        : ''}`;
    useEffect(() => {
        if (tenantId && PDFURL) {
            getFile(PDFURL).then(setPdfObject);
        }
    }, [tenantId, PDFURL]);
    return (React.createElement("div", null,
        React.createElement(File, { style: { margin: '0' }, download: true, file: {
                fileName: `${identity}.pdf`,
                contentType: 'application/pdf',
                url: PDFURL,
            } }),
        tenantId && pdfObject && (React.createElement(ObjectComp, { style: {
                marginTop: `${THEME.GRID_SPACING}px`,
                height: 'calc(100vh - 314px)',
                minHeight: '500px',
            }, type: "application/pdf", url: pdfObject }))));
};
export default PDFPreview;
//# sourceMappingURL=PDFPreview.js.map